import { secureGet, securePost } from 'config/apiConfig';

export const searchAutocomplete = async (query) => {
  const { data } = await secureGet(`/search/autocomplete?q=${encodeURIComponent(query)}`);
  return data;
};

export const searchProducts = async (query) => {
  const { data } = await secureGet(`/search?q=${encodeURIComponent(query)}`);
  return data;
};

export const getFilterCounts = async (body) => {
  const { data } = await securePost('/products/filter-counts', body);
  return data;
};
